import {API_URL} from "../config";
import axios from "../utils/axios";

class ParkingPermitRepository
{
    getAll(filter) {
        return axios.get(API_URL + "/ParkingPermit/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/ParkingPermit/${id}`);
    }

    export(filter) {
        return axios.get(API_URL + "/ParkingPermit/Export?",
            {
                params: filter,
                responseType: 'blob'
            });
    }

}

export default ParkingPermitRepository;